import React, { useState, useRef, useEffect, useMemo } from 'react';
import JoditEditor from "jodit-react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import ReturnClass from "../pages/Signup/ReturnClass";
import { useNavigate } from "react-router-dom"
import axios from "axios"
import QuestionTypeInfo from './QuestionTypeInfo'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function MasterQuestion() {

    const apiurl = window.SERVICE_URL;

    var i = 1;
    var j = 2;

    const [MainDiv, setMainDiv] = useState({ display: 'block' });
    const [SubDiv, setSubDiv] = useState({ display: 'none' });

    const editor = useRef(null)
    const [content, setContent] = useState('');

    const [AddLevel, setAddLevel] = useState(false);
    const AddLevelClose = () => setAddLevel(false);
    const handleAddLevel = () => setAddLevel(true);

    const [EditLevel, setEditLevel] = useState(false);
    const EditLevelClose = () => setEditLevel(false);
    const handleEditLevel = () => setEditLevel(true);

    const [isVar, setIsVar] = useState("d-none");

    const handleCheck = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            setIsVar("d-block");
        }
        else {
            setIsVar("d-none");
        }
    };

    if (localStorage.getItem("loginsession") != null) {
        const res = JSON.parse(localStorage.getItem("loginsession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.AccessToken = res.AccessToken;
        ReturnClass.UserID = res.UserID;
        ReturnClass.PartnerID = res.PartnerID;
    }
    const [data, dataSet] = useState([]);

    useEffect(() => {
        GetAllQuestionTypes();
    }, [dataSet]);



    function add_field() {

        var optrows = document.querySelectorAll('.options-row');
        var a = optrows[optrows.length - 1].childNodes[1].firstElementChild;
        var b = optrows[optrows.length - 1].childNodes[2].firstElementChild;
        if (a.value == "" || b.value == "") {
            a.setAttribute("style", "outline: 1px solid red;");
            b.setAttribute("style", "outline: 1px solid red;");
        } else {
            a.setAttribute("style", "outline: 1px solid black;");
            b.setAttribute("style", "outline: 1px solid black;");
            var tbody = document.getElementById('table_body');
            var elem = document.createElement('tr');
            elem.setAttribute("class", "options-row");

            elem.innerHTML = "<td>" + j + "</td><td><input type='text' style='width:90px' id='OptionText' ></td><td><input type='text' id='Marker' ></td><td><i class='fa fa-trash remove-row' aria-hidden='true'></i></td>";
            tbody.appendChild(elem);
            j = j + 1;
        }
    }

    document.addEventListener('click', (e) => {
        if (e.target.getAttribute('class').includes('remove-row')) {
            if (document.querySelectorAll('.remove-row').length > 1) {
                e.target.parentNode.parentNode.remove();
            }
        }
    })


    function Update_field() {
        var tbody = document.getElementById('table_bodyUpdate');
        var elem = document.createElement('tr');
        elem.setAttribute("class", "options-rowUpdate");
        elem.innerHTML = "<td>" + i + "</td><td><input type='text' style='width:90px' id='OptionText' ></td><td><input type='text' id='Marker' ></td><td onClick={deleteFunc}> <span ><i class='fa fa-trash remove-row' aria-hidden='true'></i></span ></td>";
        tbody.appendChild(elem);
        i = i + 1;
    }

    function spinner(e, isTrue) {
        if (isTrue) {
            e.setAttribute("style", "visibility: visible; display: block;");
        } else {
            e.setAttribute("style", "visibility: hidden; display: none;");
        }
    }


    function validateFormUpdate(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Sub Question Type";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";

            UpdateQuestionTypes();

            status = true;
        }
        return status;
    }

    function validateForm(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Sub Question Type";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddQuestionTypes();

            status = true;
        }
        return status;
    }



    //Add New Question Type
    const AddQuestionTypes = async () => {

        var name = document.getElementById("Name").value;
        var description = document.getElementById("Description").value;
        var IsSingleCorrects = document.getElementById("IsSingleCorrect").checked;


        var valuesArray = new Array();
        var optrows = document.querySelectorAll('.options-row');
        optrows.forEach((item) => {
            var options = {};
            var a = item.childNodes[1].firstElementChild.value;
            var b = item.childNodes[2].firstElementChild.value;
            options.OptionText = a;
            options.Marker = b;
            valuesArray.push(options);
        })

        var optStrJsonArray = JSON.stringify(valuesArray);

        const AddQuestionTypesForm = {
            UQuesTypeId: 0,
            UQuesTypeName: name,
            QuesTypeId: QuestionTypeInfo.QuesTypeId,
            UQuesDirection: description,
            IsSingleCorrect: IsSingleCorrects,
            PartnerID: 0,
            CreatedDate: new Date(),
            encPartnerID: ReturnClass.PartnerID,
            _objListQTypeOptions: valuesArray,
        };

        await axios.post(apiurl+`api/SaveUserQuestionType`, AddQuestionTypesForm,
            {
                headers:
                {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                    "Content-Type": "application/json",
                },
            })

            .then(function (result) {

                toast.success(result.data.outMessage);
                ////GetAllQuestionTypes();
                GetAllUserQuestionTypes(QuestionTypeInfo.QuesTypeId, name);
                AddLevelClose();
            })
            .catch(error => {
                console.log(error.response);
            });
    };

    //Update Question Type
    const UpdateQuestionTypes = async () => {


        var name = document.getElementById("Name").value;
        var description = document.getElementById("Description").value;
        var UQuesTypeIds = document.getElementById("ID").value;
        var IsSingleCorrects = document.getElementById("IsSingleCorrect").checked;
        var valuesArray = new Array();
        var optrows = document.querySelectorAll('.options-rowUpdate');

        optrows.forEach((item) => {
            var options = {};
            var a = item.childNodes[1].firstElementChild.value;
            var b = item.childNodes[2].firstElementChild.value;
            options.OptionText = a;
            options.Marker = b;
            valuesArray.push(options);
        })
        var optStrJsonArray = JSON.stringify(valuesArray);

        const UpdateQuestionTypesForm = {
            UQuesTypeId: UQuesTypeIds,
            UQuesTypeName: name,
            QuesTypeId: QuestionTypeInfo.QuesTypeId,
            UQuesDirection: description,
            IsSingleCorrect: IsSingleCorrects,
            PartnerID: 0,
            CreatedDate: new Date(),
            encPartnerID: ReturnClass.PartnerID,
            _objListQTypeOptions: valuesArray,
        };


        await axios.post(apiurl+`api/SaveUserQuestionType`, UpdateQuestionTypesForm,
            {
                headers:
                {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                    "Content-Type": "application/json",
                },
            })
            .then(function (result) {

                toast.success(result.data.outMessage);
                GetAllUserQuestionTypes(QuestionTypeInfo.QuesTypeId, name);
                EditLevelClose();
            })
            .catch(error => {
                console.log(error.response);
            });
    };

    const encPartnerID = ReturnClass.PartnerID;

    async function GetAllQuestionTypes() {
        // var spi = document.getElementById('spi');
        // spinner(spi, true);

        await axios.get(apiurl+`api/GetAllQuestionType?PartnerID=` + ReturnClass.PartnerID,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {
                //spinner(spi, false);
                dataSet(response.data);
                // QuestionTypeInfo.QuesTypeId = response.data[0].quesTypeId;

            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const [UserQuestionList, UserQuestionSet] = useState([]);
    useEffect(() => {
    }, [UserQuestionSet]);

    async function GetAllUserQuestionTypes(questypeId, QuestypeName) {
        await axios.get(apiurl+`api/GetAllUserQuestionType?PartnerID=${ReturnClass.PartnerID}&QuesTypeId=${questypeId}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
                UserQuestionSet(response.data);
                QuestionTypeInfo.QuesTypeId = questypeId;
                QuestionTypeInfo.QuesType = QuestypeName;
                setMainDiv({ display: 'none' });
                setSubDiv({ display: 'block' });
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const [UserQuestionID, UserQuestionIDSet] = useState([]);
    useEffect(() => {
    }, [UserQuestionIDSet]);


    async function GetUserQuestionTypeByIDs(QuesTypeIds, UQuesTypeIds) {
        UserQuestionIDSet([]);

        await axios.get(apiurl+`api/GetUserQuestionTypeByID?PartnerID=${encPartnerID}&QuesTypeId=${QuesTypeIds}&UQuesTypeId=${UQuesTypeIds}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
                UserQuestionIDSet(response.data);
                GetAllUserDefQTypeOptions(UQuesTypeIds);

            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const [UserQuestionTypeID, UserQuestionTypeIDSet] = useState([]);
    useEffect(() => {
    }, [UserQuestionTypeIDSet]);

    async function GetAllUserDefQTypeOptions(UserDefQTypeIds) {
        UserQuestionTypeIDSet([]);
        await axios.get(apiurl+`api/GetAllUserDefQTypeOption?PartnerID=${encPartnerID}&UserDefQTypeId=${UserDefQTypeIds}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {

                UserQuestionTypeIDSet(response.data);
                setIsVar("d-block");
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    return (
        <>
            <ToastContainer />
            <div className="alert alert-light d-flex align-items-center mb-3 px-4">
                <h5
                    className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                    style={{ fontSize: "14px" }}>
                    MASTER SETTINGS
                </h5>
                <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-danger"></span>
                <span className="text-danger font-weight-500 f13">Question Type Entities</span>
            </div>

            <div className="yoc-subheader__main bg-white px-3 mb-3 py-3">
                <Link to="/manage-settings" className="btn btn-pill btn-upper font-weight-normal ad-btn text-uppercase btn-orange waves-effect waves-light">
                    Master Settings</Link>

                <Link
                    to="/manage-user"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/ Users
                </Link>
                <a
                    type="text"
                    href="#"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/Users Rights
                </a>
            </div>

            <div className="row">
                <div className="col-lg-3 col-xl-3 order-lg-1 order-xl-1">

                    <div className="yoc-portlet yoc-portlet--head--noborder yoc-portlet--height-fluid custom-side">
                        <div className="yoc-portlet__head yoc-portlet__head--noborder">
                            <div className="yoc-portlet__head-label">
                                <div className="dropdown dropdown-inline">
                                    <span className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--success yoc-badge--rounded cursor-pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MASTER ENTERIES</span>
                                    <div
                                        className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-md custom_dropdown"
                                        x-placement="bottom-end"
                                        style={{
                                            position: "absolute",
                                            willChange: "transform",
                                            top: "0px",
                                            left: "0px",
                                            transform: "translate3d(24px, 26px, 0px)",
                                        }}>

                                        <ul className="yoc-nav p-3">
                                            <li className="yoc-nav__head d-block text-center headingList">
                                                Select Master Entry
                                                <i className="flaticon2-information" data-toggle="yoc-tooltip" data-placement="right" title="" data-original-title="Click to learn more..."></i>
                                            </li>
                                            <li className="yoc-nav__item  mt-2">
                                                <Link to="/master-question-type" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk custom-lnk">Question's Type</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item  mt-2">
                                                <Link to="/master-settings" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk ">Exam List</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-levels" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">Difficulty Level</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-question" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">Question Source</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-language" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">Language</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-author" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">Authors</span>
                                                </Link>
                                            </li>

                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-concept" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">Concept</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__item mt-2">
                                                <Link to="/master-university" className="yoc-menu__link ">
                                                    <span className="yoc-nav__link-text custom-lnk">University</span>
                                                </Link>
                                            </li>
                                            <li className="yoc-nav__separator"></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="yoc-portlet__head-toolbar">
                                <div className="dropdown dropdown-inline">
                                    <button type="button" className="btn btn-clean btn-sm btn-icon btn-icon-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="flaticon-more-1"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style={{
                                        position: "absolute",
                                        willChange: "transform",
                                        top: "0px",
                                        left: "0px",
                                        transform: "translate3d(32px, 32px, 0px)",
                                    }}>
                                        <ul className="yoc-nav">
                                            <li className="yoc-nav__item">
                                                <a href="#" className="yoc-nav__link">
                                                    <i className="yoc-nav__link-icon flaticon2-refresh"></i>
                                                    <span className="yoc-nav__link-text">Refresh</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {data.map((QuestionTypeObj, key) => (
                            <div key={key} className="yoc-portlet__body yoc-portlet__body--fluid yoc-portlet__body--fit">
                                <div className="yoc-widget4 yoc-widget4--sticky">
                                    <div className="yoc-widget4__items yoc-widget4__items--bottom  px-sm-2 px-2 yoc-margin-b-20">
                                        <div className="yoc-widget4__item left-menu-active">
                                            <div className="yoc-widget4__img yoc-widget4__img--logo">
                                                <img src="assets/media/bg/question_type.png" className="img-objective" />
                                            </div>
                                            <div className="yoc-widget4__info">
                                                <a onClick={() => { GetAllUserQuestionTypes(QuestionTypeObj.quesTypeId, QuestionTypeObj.quesType); }} className="yoc-widget4__title text-uppercase text-dark">
                                                    <span>{QuestionTypeObj.quesType}</span>
                                                </a>
                                            </div>
                                            <i className="fa fa-chevron-right text-primary" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>

                <div className="col-lg-9 col-xs-9 order-lg-2 order-xl-2">
                    <div className="yoc-portlet yoc-faq-v1" style={MainDiv}>
                        <div className="yoc-portlet__body">
                            <div className=" text-center" style={{ padding: "17% 0", background: "#f4f4f4" }}>
                                <p className="lead">Click On <span className="badge badge-dark">MASTER QUESTION TYPE</span></p>

                                <p className="lead">to select and modify or update entries</p>
                            </div>
                        </div>
                    </div>

                    <div className="yoc-portlet yoc-portlet--height-fluid yoc-portlet--mobile custom-side" style={SubDiv}>
                        <div className="alert alert-light mb-2 px-2">
                            <div className="alert alert-light d-flex align-items-center p-0 mb-0">
                                <h4 className="yoc-subheader__title ml-lg-3 ml-md-3 ml-sm-3 ml-2 f18 mb-0">
                                    <img src="assets/media/bg/question_type.png" className="img-objective" />
                                    {QuestionTypeInfo.QuesType}
                                </h4>
                                <span className="seperator ml-lg-3 ml-md-3 ml-sm-3 ml-2"></span>
                                <button className="btn rounded-0 btn-primary btn-sm" onClick={handleAddLevel}>
                                    <i className="fa fa-plus" aria-hidden="true" ></i>
                                    New Sub Question Type
                                </button>
                            </div>
                        </div>
                        <div className="yoc-portlet yoc-portlet--head--noborder yoc-portlet--height-fluid custom-side px-3 py-3 table-responsive" >
                            
                            <table className="table table-striped- table-bordered table-checkable" id="yoc_table_1">
                                <thead>
                                    <tr>
                                        <th>Sub Question Type</th>
                                        <th>Description</th>
                                        <th>Has Fixed Option </th>
                                        <th>Question Bank Strength <span className="invisible">QuesQuestionsQuestionstionsQue</span></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {UserQuestionList.map((UserQuestionTypeObj, key) => (
                                        <tr key={key}>
                                            <td data-field="ShipName">

                                                <div className="yoc-user-card-v2">

                                                    <div className="yoc-user-card-v2__pic">
                                                        <img src="assets/media/bg/question_type.png" className="img-objective" />
                                                    </div>

                                                    <div className="yoc-user-card-v2__details">
                                                        <span className="yoc-user-card-v2__name text-dark text-uppercase">
                                                            {UserQuestionTypeObj.uQuesTypeName}
                                                        </span>
                                                    </div>

                                                </div>
                                            </td>

                                            <td>
                                                {UserQuestionTypeObj.uQuesDirection}
                                            </td>

                                            <td>
                                                {String(UserQuestionTypeObj.isSingleCorrect)}
                                            </td>

                                            <td>
                                                <div className="yoc-user-card-v2">
                                                    <div className="yoc-user-card-v2__details">
                                                        <span className="yoc-user-card-v2__email ln-14">Questions Added / Corrected <strong>
                                                            <span className="text-dark">: 3009 / 500</span>
                                                        </strong> (This Month)
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="yoc-user-card-v2">
                                                    <div className="yoc-user-card-v2__details">
                                                        <span className="yoc-user-card-v2__email ln-14">Questions  Created <strong>
                                                            <span className="text-dark">: 3009</span>
                                                        </strong> (Till Date)
                                                        </span>
                                                    </div>
                                                </div>

                                            </td>

                                            <div className="dropdown ">
                                                <button
                                                    type="button"
                                                    className="btn btn-clean btn-sm btn-icon btn-icon-lg"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <i className="flaticon-more-1"></i>
                                                </button>
                                                <div
                                                    className="dropdown-menu dropdown-menu-right"
                                                    x-placement="bottom-end"
                                                    style={{
                                                        position: "absolute",
                                                        willChange: "transform",
                                                        top: "0px",
                                                        left: "0px",
                                                        transform: "translate3d(32px, 32px, 0px)",
                                                    }}
                                                >
                                                    <ul className="yoc-nav">
                                                        <li className="yoc-nav__item">
                                                            <a className="yoc-nav__link" onClick={() => { GetUserQuestionTypeByIDs(UserQuestionTypeObj.quesTypeId, UserQuestionTypeObj.uQuesTypeId); handleEditLevel(); }}>
                                                                <i className="yoc-nav__link-icon la la-pencil"></i>
                                                                <span className="yoc-nav__link-text">Edit</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </tr>
                                    )).reverse()}
                                </tbody>

                            </table>
                        </div>

                    </div>
                </div>

            </div>

            <Modal
                show={AddLevel}
                onHide={AddLevelClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>ADD SUB QUESTION TYPE </Modal.Title>
                        <div className="ml-2  ">
                            <span className="beside-md-header ">
                                Question Type : <span>{QuestionTypeInfo.QuesType}</span>
                            </span>
                        </div>
                        <Button onClick={AddLevelClose}>X</Button>

                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-8">
                                <div>
                                    <p>Name:</p>
                                    <input
                                        type="text"
                                        className="form-control "
                                        placeholder="Name"
                                        aria-describedby=""
                                        id="Name"
                                        name="name"
                                    />
                                    <span id="nameVal"></span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <select
                                    className="form-control form-control-sm bg-label-primary-cs"
                                    id=""
                                    style={{ marginTop: "35px" }}
                                >
                                    <option>English</option>
                                    <option>Spanish</option>
                                    <option>German</option>
                                    <option>Hindi</option>
                                    <option>French</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="Description"
                                    name="Description"
                                />
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-12 pr-0 pt-2">
                                    <label
                                        className="yoc-checkbox yoc-checkbox--bold yoc-checkbox--success"
                                        style={{ paddingRight: 30, paddingLeft: 0 }}
                                    >
                                        Is Single Correct
                                        <input type="checkbox" id="IsSingleCorrect" name="IsSingleCorrect" />
                                        <span style={{ left: "auto", right: 0 }} />
                                    </label>
                                </div>

                                <div className="col-md-12 pr-0 pt-2">
                                    <label
                                        className="yoc-checkbox yoc-checkbox--bold yoc-checkbox--success"
                                        style={{ paddingRight: 30, paddingLeft: 0 }}
                                    >
                                        Invariable Options (fixed options){" "}
                                        <input type="checkbox" id="inVar" name="inVar" onChange={handleCheck} />
                                        <span style={{ left: "auto", right: 0 }} />
                                    </label>
                                </div>


                            </div>
                            <div className={isVar} >
                                <div className="row px-2">
                                    <div className="col-md-8">
                                        <h5 className="f15 mb-0 text-dark">Add Options </h5>
                                    </div>
                                    <div className="col-md-4">
                                        <select
                                            className="form-control form-control-sm bg-label-primary-cs"
                                            id=""
                                        >
                                            <option>English</option>
                                            <option>Spanish</option>
                                            <option>German</option>
                                            <option>Hindi</option>
                                            <option>French</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 mt-1">
                                        <table className='table border' id="tbl-options">
                                            <thead>
                                                <tr className="bg-danger" style={{ color: "white" }}>
                                                    <td> <b>S.no</b></td>
                                                    <td> <b>Option Mark</b> </td>
                                                    <td> <b>Option Text</b></td>
                                                    <td> <b>Delete</b>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody id="table_body">
                                                <tr class="options-row">
                                                    <td>1</td>
                                                    <td>
                                                        <input required type="text" style={{ width: "90px" }} id="OptionText" />
                                                    </td>
                                                    <td>
                                                        <input required type="text" id="Marker" />
                                                    </td>
                                                    <td>
                                                        <i class="fa fa-trash remove-row" aria-hidden="true"></i>
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>
                                    <div className="col-md-12">
                                        <div className='d-flex justify-content-end'>
                                            {/*<button class="btn rounded-0 btn-primary btn-sm waves-effect waves-light mr-2" onClick={add_field}><i class="fa fa-plus" aria-hidden="true"></i>Add more Options</button>*/}
                                            <input type="button" value="Add More Row" onClick={add_field} class="btn rounded-0 btn-primary btn-sm waves-effect waves-light mr-2" />

                                            {/*<button class="btn rounded-0 btn-primary btn-sm waves-effect waves-light" >Submit</button>*/}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateForm}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={AddLevelClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={EditLevel}
                onHide={EditLevelClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>Update SUB QUESTION TYPE </Modal.Title>
                        <div className="ml-2  ">
                            <span className="beside-md-header ">
                                Question Type : <span>{QuestionTypeInfo.QuesType}</span>
                            </span>
                        </div>
                        <Button onClick={EditLevelClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-8">
                                <div>
                                    <input
                                        type="hidden"
                                        className="form-control "
                                        placeholder="ID"
                                        aria-describedby=""
                                        id="ID"
                                        name="ID"
                                        defaultValue={UserQuestionID.uQuesTypeId}
                                    />
                                    <p>Name:</p>
                                    <input
                                        type="text"
                                        className="form-control "
                                        placeholder="Name"
                                        aria-describedby=""
                                        id="Name"
                                        name="name"
                                        defaultValue={UserQuestionID.uQuesTypeName}
                                    />
                                    <span id="nameVal"></span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <select
                                    className="form-control form-control-sm bg-label-primary-cs"
                                    id=""
                                    style={{ marginTop: "35px" }}
                                >
                                    <option>English</option>
                                    <option>Spanish</option>
                                    <option>German</option>
                                    <option>Hindi</option>
                                    <option>French</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group row mb-3 yoc-margin-t-10">
                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={UserQuestionID.uQuesDirection}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={(newContent) => { }}
                                    id="Description"
                                    name="Description"
                                />
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-12 pr-0 pt-2">
                                    <label
                                        className="yoc-checkbox yoc-checkbox--bold yoc-checkbox--success"
                                        style={{ paddingRight: 30, paddingLeft: 0 }}
                                    >
                                        Is Single Correct
                                        <input type="checkbox" id="IsSingleCorrect" name="IsSingleCorrect" />
                                        <span style={{ left: "auto", right: 0 }} />
                                    </label>
                                </div>

                                <div className="col-md-12 pr-0 pt-2">
                                    <label
                                        className="yoc-checkbox yoc-checkbox--bold yoc-checkbox--success"
                                        style={{ paddingRight: 30, paddingLeft: 0 }}
                                    >
                                        Invariable Options (fixed options){" "}
                                        <input
                                            type="checkbox"
                                            id="inVar"
                                            name="inVar"
                                            checked="checked"
                                            onChange={handleCheck}
                                        />
                                        <span style={{ left: "auto", right: 0 }} />
                                    </label>
                                </div>
                            </div>
                            <div className={isVar}>
                                <div className="row px-2">
                                    <div className="col-md-8">
                                        <h5 className="f15 mb-0 text-dark">Add Options </h5>
                                    </div>
                                    <div className="col-md-4">

                                        <select
                                            className="form-control form-control-sm bg-label-primary-cs"
                                            id=""
                                        >
                                            <option>English</option>
                                            <option>Spanish</option>
                                            <option>German</option>
                                            <option>Hindi</option>
                                            <option>French</option>
                                        </select>

                                    </div>
                                    <div className="col-md-12 mt-1">
                                        <table className="table border">
                                            <thead>
                                                <tr style={{ color: "white", backgroundColor: "#ce1e16" }}>
                                                    <td>
                                                        {" "}
                                                        <b>S.no</b>
                                                    </td>
                                                    <td>
                                                        {" "}
                                                        <b>Option Mark</b>{" "}
                                                    </td>
                                                    <td>
                                                        {" "}
                                                        <b>Option Text</b>
                                                    </td>
                                                    <td>
                                                        {" "}
                                                        <b>Delete</b>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody id="table_bodyUpdate">
                                                {UserQuestionTypeID.map((UserQuestionTypeIDobj, key) => (
                                                    <tr key={key} class="options-rowUpdate">
                                                        <td>{i++}</td>
                                                        <td><input type="text" defaultValue={UserQuestionTypeIDobj.marker} /></td>
                                                        <td><input type="text" defaultValue={UserQuestionTypeIDobj.optionText} /></td>
                                                        <td align="center">
                                                            <a href="#">
                                                                {/* <i className="fas fa-trash text-danger" />*/}
                                                                <i className="fa fa-trash remove-row" />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-end">
                                            <input type="button" value="Add TextBox" onClick={Update_field} class="btn rounded-0 btn-primary btn-sm waves-effect waves-light mr-2" />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormUpdate}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditLevelClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

        </>
    )
}

export default MasterQuestion
